import XMLParser from "react-xml-parser";
import { CONSTANTS, MAX_LAB_VALUES } from "../utils/constant";

// it will convert the file object to array Buffer
export const convertToArrayBuffer = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onabort = () => console.log("file reading was aborted");
    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = (error) => {
      reject({ error: error, file: file }); // Reject with the error AND the file
    };

    if (!file) {
      // Check for null or undefined file Reject with a specific error
      reject({ error: "Invalid file format", file: null });
      // Important: Stop further execution
      return;
    }

    reader.readAsArrayBuffer(file);

    reader.onload = () => {
      const arrayBuffer = reader.result;
      resolve(arrayBuffer);
    };
  });
};

//  we are using npm dependency XMLParser to convert the array buffer to xmlJson
export const parseCXFData = (arrayBuffer) => {
  // Convert arrayBuffer to a string (assuming UTF-8 encoding)
  const cxfString = new TextDecoder().decode(arrayBuffer);
  var xmlJson = new XMLParser().parseFromString(cxfString);

  return xmlJson;
};

/* 
  This will find the RT curve and before saving in state there is validation logic
  wavelength start and end from 400 to 700 respectively and step is 10
  This loop parse requirement stepper popup cxf files
*/
export const findRTCurveValues = (xmlJson) => {
  let rCurveData = xmlJson.getElementsByTagName("cc:ReflectanceSpectrum")[0];
  let tCurveData = xmlJson.getElementsByTagName("cc:TransmittanceSpectrum")[0];

  // Starting wavelength of R curve
  let startWLR = rCurveData.attributes.StartWL;
  // Starting wavelength of T curve
  let startWLT = tCurveData.attributes.StartWL;
  //startWL should not be greater than 400
  let indexR = parseInt(startWLR) <= 400 ? (400 - parseInt(startWLR)) / 10 : -1;
  let indexT = parseInt(startWLT) <= 400 ? (400 - parseInt(startWLT)) / 10 : -1;

  let rCurve = rCurveData.value
    .split(" ")
    .slice(indexR)
    .map((e) => parseFloat(e));
  let tCurve = tCurveData.value
    .split(" ")
    .slice(indexT)
    .map((e) => parseFloat(e));
  if (
    indexR == -1 ||
    indexT == -1 ||
    rCurve.length < CONSTANTS.rtCurveLength ||
    tCurve.length < CONSTANTS.rtCurveLength
  ) {
    return -1;
  }
  return {
    rCurve: rCurve.slice(0, CONSTANTS.rtCurveLength),
    tCurve: tCurve.slice(0, CONSTANTS.rtCurveLength),
  };
};

/* 
  Input color page
  Read only cielab values
*/
export const findInputColorsRTCurveValues = (xmlJson) => {
  let ObjectData = [];
  let cxfObj = [];
  if (xmlJson.getElementsByTagName("cc:Object").length > 0) {
    /* Handle normal cxf file here */
    ObjectData = xmlJson.getElementsByTagName("cc:Object");
    cxfObj = exportNormalCxf(ObjectData, xmlJson);
    console.log("inside the normla cxf file");
  } else if (xmlJson.getElementsByTagName("Object")) {
    /* Colorgrail cxf */
    ObjectData = xmlJson.getElementsByTagName("Object");
    cxfObj = exportColorGrailFile(ObjectData, xmlJson);
    console.log("colorgrail cxf file");
  }
  return cxfObj;
};

const exportColorGrailFile = (ObjectData, xmlJson) => {
  let counter = 1;
  let cxfObj = [];

  ObjectData.map((data, index) => {
    if (data?.attributes?.ObjectType === "Standard") {
      if (
        data?.children[1]?.children[1]?.name === "ReflectanceSpectrum" &&
        counter <= MAX_LAB_VALUES
      ) {
        const colorValues = data?.children[1]?.children[0].children;
        const opacity = data?.children[2]?.children[0].value;
        console.log(colorValues);
        let L = colorValues[0]?.value || null;
        let a = colorValues[1]?.value || null;
        let b = colorValues[2]?.value || null;

        counter++;
        cxfObj.push({
          name: data.attributes.Name,
          L: L ? parseFloat(L) : null,
          a: a ? parseFloat(a) : null,
          b: b ? parseFloat(b) : null,
          opacity: opacity,
        });
      }
    }
  });
  return cxfObj;
};

const exportNormalCxf = (ObjectData, xmlJson) => {
  // access by using cc: object or by normal object

  /*  As discussed with safdar need to take ColorCIELAB values for now 
    let rCurveData = xmlJson.getElementsByTagName('cc:ReflectanceSpectrum');
    let tCurveData = xmlJson.getElementsByTagName('cc:TransmittanceSpectrum');
  */

  /* Check for all three counts if not matched show invalid file format error */
  let colorData = xmlJson.getElementsByTagName("cc:ColorCIELab");
  let opacityData = xmlJson.getElementsByTagName("cc:Opacity");
  /* Take first 100 LAB values only */

  let counter = 1;
  let cxfObj = [];
  console.log(ObjectData);
  ObjectData.map((data, index) => {
    // Add condition here to manage the inputs
    if (
      data?.attributes?.ObjectType === "Standard" ||
      data?.attributes?.ObjectType === "Trial"
    ) {
      //if (counter <= MAX_LAB_VALUES) {

      /* code to check the reflectancespectram */
      let isReflectanceSpectrum = validateReflectanceSpectrum(data);
      console.log(isReflectanceSpectrum);

      if (isReflectanceSpectrum && counter <= MAX_LAB_VALUES) {
        /*   
            Not in current MVP scope
            let startWLR = rCurveData[index]?.attributes?.StartWL;
            let startWLT = tCurveData[index]?.attributes?.StartWL;

            let indexR =
              parseInt(startWLR) <= 400 ? (400 - parseInt(startWLR)) / 10 : -1;
            let indexT =
              parseInt(startWLT) <= 400 ? (400 - parseInt(startWLT)) / 10 : -1;

            let rCurve = rCurveData[index].value
              .split('')
              .slice(indexR)
              .map((e) => parseFloat(e));
            let tCurve = tCurveData[index].value
              .split('')
              .slice(indexT)
              .map((e) => parseFloat(e));
        */
        let opacity = 0;
        if (opacityData[index]?.value) {
          opacity = parseFloat(opacityData[index].value);
        }

        /*
        Not in current MVP scope 
        
          if (
            indexR == -1 ||
            indexT == -1 
            // || rCurve.length < CONSTANTS.rtCurveLength ||
          // tCurve.length < CONSTANTS.rtCurveLength
          ) {
            // -1 indicate error in CFX file
            return -1;
          }
      */
        // Extract the CIELab values (L, a, b) for the color
        let cieLab = colorData[index];
        let L = cieLab.getElementsByTagName("cc:L")[0]?.value || null;
        let a = cieLab.getElementsByTagName("cc:A")[0]?.value || null;
        let b = cieLab.getElementsByTagName("cc:B")[0]?.value || null;

        counter++;
        cxfObj.push({
          name: data.attributes.Name,
          L: L ? parseFloat(L) : null,
          a: a ? parseFloat(a) : null,
          b: b ? parseFloat(b) : null,
          //rCurve: rCurve.slice(0, CONSTANTS.rtCurveLength),
          //tCurve: tCurve.slice(0, CONSTANTS.rtCurveLength),
          opacity: opacity,
        });
      }
    }
  });
  return cxfObj;
};

const validateReflectanceSpectrum = (data) => {
  // Ensure 'data' and 'data.children' exist to prevent errors.
  // Using a for...of loop for efficient iteration and early exit.
  if (data?.children) {
    // Optional chaining for safe access
    for (const item of data.children) {
      // If 'item' is a "cc:ColorValues" and has children, proceed.
      if (item.name === "cc:ColorValues" && item.children) {
        // Iterate through the children of "cc:ColorValues".
        for (const child of item.children) {
          // If "cc:ReflectanceSpectrum" is found, we can immediately return true.
          if (child.name === "cc:ReflectanceSpectrum") {
            return true; // Found it, no need to continue looping.
          }
        }
      }
    }
  }
  // If the loop completes without finding it, return false.
  return false;
};
